//////////////////////////////////////////////////////////////////////////////
// Routes
//////////////////////////////////////////////////////////////////////////////
export const ROUTE_LOGIN = 'login'
export const ROUTE_LOGIN_LOGOUT = 'logout'

export const ROUTE_SOURCES = 'sources'
export const ROUTE_SOURCES_HOME = 'home'

export const ROUTE_SCRIPTS = 'scripts'
export const ROUTE_SCRIPTS_HOME = 'home'

//////////////////////////////////////////////////////////////////////////////
// Route params
//////////////////////////////////////////////////////////////////////////////
export const ROUTE_PARAM_PROJECT_ID = 'projectId'
